import ProfileForm from '@widgets/profile/ProfileForm';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { theme } from '@utils/libs/theme';
import useMediaQuery from '@mui/material/useMediaQuery';
import { getUserRole } from '@shared/static/roles';
import { useNavigate } from 'react-router-dom';
import { ThemeButtonIcon } from '@shared/ui/buttons';

export default function ProfilePage() {
  const { user } = useSelector((state) => state.user);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const title = isMobile ? t('profile') : user?.name;
  const subtitle = isMobile ? t(getUserRole(user?.group_role)) : t('profile');

  return (
    <section className="profile main-section">
      <div className="block-pd-y block-pd-x">
        <div className="main-section-title">
          <h2 className="title-h2m">
            {title} <span>{subtitle}</span>
          </h2>
          {isMobile && (
            <ThemeButtonIcon icon="close" onClick={() => navigate(-1)} />
          )}
        </div>
      </div>
      <div className="block-pd-y block-pd-x">
        <ProfileForm />
      </div>
    </section>
  );
}
